var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "github__Property 1=Github",
    className: "github__Property github__1=Github"
  }, /*#__PURE__*/React.createElement("g", {
    id: "github__Integrations",
    className: "github__Integrations"
  }, /*#__PURE__*/React.createElement("g", {
    id: "github__GitHub_idhzJ1h-fp_3 1",
    className: "github__GitHub_idhzJ1h-fp_3 github__1",
    clipPath: "url(#github__clip0_16058_193805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "github__Group",
    className: "github__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "github__Vector",
    fill: "#161614",
    d: "M12 1.436C5.78 1.436.736 6.479.736 12.7c0 4.976 3.228 9.199 7.703 10.688.563.104.77-.244.77-.542 0-.268-.01-1.156-.015-2.097-3.134.681-3.795-1.329-3.795-1.329-.513-1.302-1.25-1.648-1.25-1.648-1.023-.7.076-.685.076-.685 1.131.08 1.727 1.16 1.727 1.16 1.005 1.723 2.635 1.225 3.278.937.1-.728.393-1.225.715-1.506-2.502-.285-5.132-1.25-5.132-5.567 0-1.23.44-2.234 1.16-3.023-.116-.284-.502-1.43.11-2.981 0 0 .946-.303 3.098 1.155.899-.25 1.862-.375 2.82-.38.957.005 1.921.13 2.821.38 2.15-1.458 3.095-1.155 3.095-1.155.613 1.552.227 2.697.11 2.98.722.79 1.16 1.795 1.16 3.024 0 4.327-2.636 5.28-5.144 5.558.404.35.764 1.035.764 2.086 0 1.507-.013 2.72-.013 3.091 0 .3.203.651.774.54 4.473-1.49 7.696-5.711 7.696-10.686 0-6.221-5.043-11.264-11.264-11.264ZM4.955 17.482c-.025.055-.113.072-.193.034-.082-.037-.128-.113-.101-.17.024-.057.112-.073.194-.034.082.036.128.113.1.17Zm.554.494c-.054.05-.159.027-.23-.052-.074-.079-.087-.184-.033-.234.056-.05.157-.027.231.052.074.08.088.183.032.234Zm.38.632c-.069.048-.182.003-.251-.097-.07-.1-.07-.22.001-.268.07-.048.181-.005.252.094.069.102.069.222-.002.271Zm.643.733c-.062.068-.193.05-.29-.043-.098-.09-.125-.22-.063-.288.062-.068.194-.049.291.043.098.09.128.22.062.288Zm.83.247c-.026.088-.153.129-.28.091-.128-.038-.211-.142-.186-.23.027-.09.154-.132.283-.091.127.038.21.14.184.23Zm.946.105c.004.093-.105.17-.238.172-.135.003-.244-.072-.246-.164 0-.094.106-.17.24-.172.135-.003.244.072.244.164Zm.93-.035c.015.09-.078.183-.21.208-.131.024-.253-.032-.27-.122-.015-.093.08-.186.21-.21.133-.023.252.032.27.124Z",
    className: "github__Vector"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "github__clip0_16058_193805",
    className: "github__clip0_16058"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.736 1.436h22.528v22H.736z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.97a04f20dd7042246cda7f5bd82126c9.svg";
export { ForwardRef as ReactComponent };